import { TeamResponse } from 'api';
import getOrganisationsDiff from 'utils/getOrganisationDiff';
import { TeamData } from './types';

type TeamDetails = Pick<TeamData, 'name' | 'visibility' | 'selectedOrgs'>;

const hasTeamDetailsChanged = (
  team: TeamResponse,
  { name, visibility, selectedOrgs = [] }: TeamDetails,
): boolean => {
  const { add, remove } = getOrganisationsDiff(
    team.organisationContext?.organisations ?? [],
    selectedOrgs,
  );

  return (
    (name ?? '').trim() !== team.name.trim() ||
    (visibility ?? 'PRIVATE') !== (team.visibility ?? 'PRIVATE') ||
    add.length > 0 ||
    remove.length > 0
  );
};

export default hasTeamDetailsChanged;
